import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

export default createServiceProvider({
  ...getServiceProvider('openapi'),
  titleToNamespace: true,
  hasConnectionStatus: false,
  avatarPath: avatars.openapi,
  logoPath: logos.openapi
});
